import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

import { SharedService } from 'src/app/core/services/shared.service';

declare const UIkit: any;

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styles: ['.uk-modal-dialog { white-space: pre-wrap; } .error-modal-header { margin: 0 10px; }']
})
export class ErrorModalComponent implements OnInit {
  @Input() text: string;
  @ViewChild('modal', { static: true }) modal: ElementRef;

  constructor(private sharedService: SharedService) {}

  ngOnInit() {
    UIkit.modal('#errorModal').show();

    UIkit.util.on('#errorModal', 'hidden', this.sharedService.deleteModal.bind(this, this.modal));
  }
}
